import React from 'react';

interface AJLogoLoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
}

export const AJLogoLoader: React.FC<AJLogoLoaderProps> = ({ size = 'md', text }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24',
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div className="relative">
        {/* Spinning gradient ring */}
        <div className={`${sizeClasses[size]} rounded-full bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 animate-spin`} 
             style={{ padding: '3px' }}>
          <div className="w-full h-full rounded-full bg-white dark:bg-gray-900"></div>
        </div>
        
        {/* AJ Logo in center */}
        <div className={`absolute inset-0 flex items-center justify-center`}>
          <img 
            src="/aj-logo.jpg" 
            alt="AJ STUDIOZ" 
            className={`${sizeClasses[size === 'sm' ? 'sm' : size === 'md' ? 'sm' : size === 'lg' ? 'md' : 'lg']} rounded-full object-cover shadow-md`}
            style={{
              width: size === 'sm' ? '26px' : size === 'md' ? '38px' : size === 'lg' ? '52px' : '80px',
              height: size === 'sm' ? '26px' : size === 'md' ? '38px' : size === 'lg' ? '52px' : '80px',
            }}
          />
        </div>
      </div>
      
      {text && (
        <p className={`${textSizeClasses[size]} font-medium text-gray-600 dark:text-gray-400 animate-pulse`}>
          {text}
        </p>
      )}
    </div>
  );
};
